// Botón primario de toda la app, estilo Spotify: BLANCO con texto negro.
// En hover escala levemente y se atenúa; el ::before es un velo oscuro tenue para
// reforzar el feedback. Sin dorado de relleno (el dorado es solo acento puntual).

const EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';

export const primaryButtonBaseStyles = (theme) => ({
  background: theme.palette.primaryCta.bg,
  color: theme.palette.primaryCta.text,
  fontSize: theme.typography.pxToRem(14),
  fontWeight: 700,
  position: 'relative',
  textTransform: 'none',
  transition: `transform 200ms ${EASE}, filter 200ms ${EASE}`,
  '&:hover': {
    background: theme.palette.primaryCta.bg,
    transform: 'scale(1.02)'
  },
  '&:active': {
    transform: 'scale(0.98)'
  },
  '& span': {
    zIndex: 1
  }
});

export const primaryButtonHoverStyles = {
  background: 'rgba(0, 0, 0, 0.06)',
  borderRadius: '4px'
};

export const primaryButtonPseudoElementStyles = (theme) => ({
  content: '""',
  display: 'block',
  height: '100%',
  left: 0,
  opacity: 0,
  position: 'absolute',
  top: 0,
  transition: `opacity ${theme.transitions.easing.easeInOut} ${theme.transitions.duration.short}ms`,
  width: '100%'
});
